import React, { useEffect, useState } from 'react';
import { CProgress } from '@coreui/react';

const CaloriesWidget = ({ calories }) => {
  const [displayCalories, setDisplayCalories] = useState(0);
 // console.log("Calories in widget:", calories);
  // Use useEffect to update the widget when caloriesToday changes
  useEffect(() => {
    if (calories !== undefined && calories !== null) {
      setDisplayCalories(calories);  // Update state when the prop changes
    }
  }, [calories]);  // This effect runs whenever caloriesToday prop changes

  // Assuming 3000 kcal is the target for the progress bar
  const progressValue = (displayCalories / 3000) * 100;

  return (
    <div>
      <div className="mb-2">Calories Burned Today</div>
      
      <strong>{displayCalories} kcal</strong>
      <CProgress className="CProgress-xs mt-2" color="info" value={progressValue} />
    </div>
  );
};

export default CaloriesWidget;


